<main id="home-page">
  <div class="container main-panel">
    <div class="row margin-bottom-20" style="display: inline">
      <app-header-ad [position]="'top'"></app-header-ad>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="panel mission-banner"
          style="margin-bottom: 20px; border: 1px solid transparent; border-radius: 4px;">
          <span
            style="color: white; font-family: ralway, sans-serif; font-size: 24px; margin-top: 20px; margin-bottom: 10px; line-height: 1.1; display: block;">Our
            mission is to provide
            <strong>high-quality videos and articles</strong> to help people
            learn about the law.</span>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xl-3 col-md-6 nav-panel-wrap">
        <a [routerLink]="['/coursewareview']" class="panel nav-panel courseware-panel"
          style="background-image: url('assets/img/course.png');">
          <div class="panel-text-wrap">
            <h2>Foundations of Law</h2>
            <span>In-depth online summaries of major law topics</span>
          </div>
          <div class="nav-panel-bkgd"></div>
        </a>
      </div>
      <div class="col-xl-3 col-md-6 nav-panel-wrap">
        <a [routerLink]="['/shortvideosview']" class="panel nav-panel videos-panel"
          style="background-image: url('/assets/img/videos-img.png');">
          <div class="panel-text-wrap">
            <h2>Short Videos</h2>
            <span><br />Short Videos on a broad range of legal topics</span>
          </div>
          <div class="nav-panel-bkgd"></div>
        </a>
      </div>
      <div class="col-xl-3 col-md-6 nav-panel-wrap">
        <a [routerLink]="['/videocoursesview']" class="panel nav-panel blog-panel"
          style="background-image: url('assets/img/certificates-img.png');">
          <div class="panel-text-wrap">
            <h2>Video-Courses</h2>
            <span>Multi-part comprehensive courses</span>
          </div>
          <div class="nav-panel-bkgd"></div>
        </a>
      </div>
      <div class="col-xl-3 col-md-6 info-panel-wrap">
        <a [routerLink]="['/researchindexview']" class="panel nav-panel digitalbadges-panel"
          style="background-image: url('/assets/img/research-img.png');">
          <div class="panel-text-wrap">
            <h2>Research Index</h2>
            <span>Explore legal terms</span>
          </div>
          <div class="nav-panel-bkgd"></div>
        </a>
      </div>
    </div>
    <div class="row row-left-panel">
      <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12 info-panel-wrap">
        <a [routerLink]="['/videocoursesview']" class="panel info-panel left-panel"
          style="background-image: url('/assets/img/lawyers.jpg');">
          <div class="panel-text-wrap">
            <h3 style="font-size: 24px">Complete our Video-Courses!</h3>
            <div class="underlines"></div>
            <p>
              Comprehensive video-courses developed by our expert attorneys. New
              courses added every 1-2 weeks.
            </p>
            <p>
              Earn a digital badge credential to display on your LinkedIn page.
            </p>
            <p>Stay current with the law by watching and learning.</p>
            <p class="info-panel-link">
              More Information
              <i class="fa fa-caret-right" aria-hidden="true"></i>
            </p>
          </div>
          <div class="info-panel-bkgd"></div>
        </a>
      </div>
      <div class="col-xl-6 col-lg-12  col-md-12 col-sm-12 info-panel-wrap">
        <div class="info-panel right-panel">
          <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
            <ol class="carousel-indicators">
              <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
              <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
              <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
              <li data-target="#carouselExampleIndicators" data-slide-to="3"></li>
            </ol>
            <div class="carousel-inner">
              <div *ngFor="let aFeaturedContent of featuredContent; let i = index" [ngClass]="getSlideClass(i)">
                <a [href]="
                    getDestination(
                      aFeaturedContent.Area,
                      aFeaturedContent.Information.Alias
                    )
                  "
                  style="cursor: pointer; padding-left: 15px; padding-right: 15px; font-weight: 700; margin-top: 20px; margin-bottom: 10px">
                  <div class="row">
                    <div class="col-sm-12"
                      style="padding-left: 20px;margin-bottom: 10px;font-size: 1em;height: 60px; overflow: visible; margin-top: 10px; padding-right: 15px">
                      <span *ngIf="aFeaturedContent.Area == 3" style="margin-left: 10px; color: #d67521;">Featured
                        Video-Course:
                      </span>
                      <span *ngIf="aFeaturedContent.Area == 3"
                        style="color: #337ab7">{{ aFeaturedContent.Information.Title }}</span>
                      <span *ngIf="aFeaturedContent.Area != 3" style="margin-left: 10px; color: #d67521;">Featured
                        Video: </span><span *ngIf="aFeaturedContent.Area != 3"
                        style="color: #337ab7">{{ aFeaturedContent.Information.Title }}</span>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-sm-4 text-align-center">
                      <img loading="lazy" *ngIf="aFeaturedContent.ImageBinaryAssetID" [src]="
                          getEntryImageUrl(aFeaturedContent.ImageBinaryAssetID)
                        " alt="Featured Image" style="max-height: 140px; max-width: 170px; padding-top: 5px" />
                      <img loading="lazy" *ngIf="!aFeaturedContent.ImageBinaryAssetID"
                        src="/assets/img/favicon/ms-icon-310x310.png" alt="Featured Image" height="140" />
                    </div>
                    <div class="col-sm-8" style="height: 230px; font-size: 13px">
                      <span [innerHTML]="aFeaturedContent.Information.Description" style="color: #337ab7">
                      </span>
                      <div class="more-less-btn-wrap" style="font-size: 18.2px; color: #d67521">
                        more...
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row margin-bottom-20" style="display: inline">
      <app-header-ad [position]="'bottom'"></app-header-ad>
    </div>
  </div>
</main>